/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export enum StatusLevel {
  RED = 'red',
  NEUTRAL = 'neutral',
  YELLOW = 'yellow',
  GREEN = 'green',
}

export type StatusLevelString = 'red' | 'neutral' | 'yellow' | 'green';

@Component({
  selector: 'status-output-param',
  templateUrl: './status-output-param.component.html',
  styleUrls: ['./status-output-param.component.scss'],
  standalone: true,
  imports: [MatIconModule],
})
export class StatusOutputParamComponent<T> implements OnInit {
  @Input()
  level?: StatusLevel | StatusLevelString;

  @Input()
  icon?: string;

  @Input()
  svgIcon?: string;

  @Input()
  value!: T;

  @ViewChild('innerTemplate', { static: true })
  public innerTemplate!: TemplateRef<any>;

  ngOnInit() {
    if (!this.svgIcon && !this.icon)
      console.warn('If svgIcon or Icon is not needed, please use @switch instead of status-output.');
  }
}
